import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { applyClasses, capitalize } from '../../lib';

type MaxWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
type Classes = {
  root: any;
  maxWidthXl: any;
  maxWidthLg: any;
  maxWidthMd: any;
  maxWidthSm: any;
  maxWidthXs: any;
  [key: string]: any;
};

@Component
export default class ClContainer extends Vue {
  @Prop({
    type: [String, Boolean],
    default: 'lg'
  })
  readonly maxWidth!: MaxWidth;

  @Prop({
    type: Object as () => Classes,
    default: () => ({
      root: '',
      maxWidthXl: '',
      maxWidthLg: '',
      maxWidthMd: '',
      maxWidthSm: '',
      maxWidthXs: ''
    })
  })
  readonly classes!: Classes;

  get rootClassNames() {
    return applyClasses(
      {
        'cl-container': true,
        [`cl-container--max-width-${this.maxWidth}`]: this.maxWidth !== false
      },
      this.classes.root,
      this.maxWidth !== false &&
        this.classes[`maxWidth${capitalize(String(this.maxWidth))}`]
    );
  }

  render(h: CreateElement) {
    return <div class={this.rootClassNames}>{this.$slots.default}</div>;
  }
}
